import type React from 'react';
import { Outlet } from 'react-router';
import { usePreserveSearchParams } from '../lib/hooks/usePreserveSearchParams';

export const PreserveSearchParams: React.FC<{ paramKeys: string[] }> = ({ paramKeys }) => {
  usePreserveSearchParams(paramKeys);
  return <Outlet />;
};
